import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation, matchPath } from 'react-router-dom';
import '../styles/Navbar.css';
import logo from '../assets/images/Navbar_Logo.png';

// Floating language toggle component
const LanguageToggle = () => {
  const [currentLang, setCurrentLang] = useState('en');

  useEffect(() => {
    const getLang = () => {
      const match = document.cookie.match(/googtrans=\/en\/(ar|en)/);
      if (match) setCurrentLang(match[1]);
      else setCurrentLang('en');
    };
    getLang();
    const interval = setInterval(getLang, 1000);
    return () => clearInterval(interval);
  }, []);

  const changeLanguage = (lang) => {
    document.cookie = `googtrans=/en/${lang};path=/;domain=${window.location.hostname}`;
    document.cookie = `googtrans=/en/${lang};path=/`;
    window.location.reload();
  };

  return (
    <div className="language-toggle notranslate" translate="no">
      <button
        onClick={() => changeLanguage('en')}
        className={currentLang === 'en' ? 'active' : ''}
        title="English"
        aria-label="Switch to English"
        translate="no"
      >EN</button>
      <button
        onClick={() => changeLanguage('ar')}
        className={currentLang === 'ar' ? 'active' : ''}
        title="Arabic"
        aria-label="Switch to Arabic"
        translate="no"
      >AR</button>
    </div>
  );
};

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [showNavbar, setShowNavbar] = useState(true);
  const lastScrollY = useRef(window.scrollY);
  const location = useLocation();

  // Detect if on blog detail page
  const isBlogDetail = !!matchPath('/blog/:slug', location.pathname);
  // Detect if on privacy or terms pages
  const isPolicyOrTerms = location.pathname === '/privacy-policy' || location.pathname === '/terms-and-conditions';

  useEffect(() => {
    let ticking = false;
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      const isScrolled = currentScrollY > 50;
      // Only update state if value actually changes
      setScrolled(prev => {
        if (prev !== isScrolled) return isScrolled;
        return prev;
      });
      // Only apply hide/show logic for blog detail, not for policy/terms
      if (isBlogDetail && !isPolicyOrTerms) {
        if (!ticking) {
          window.requestAnimationFrame(() => {
            setShowNavbar(prevShow => {
              if (currentScrollY > lastScrollY.current && currentScrollY > 80) {
                if (prevShow !== false) return false;
              } else {
                if (prevShow !== true) return true;
              }
              return prevShow;
            });
            lastScrollY.current = currentScrollY;
            ticking = false;
          });
          ticking = true;
        }
      } else if (isPolicyOrTerms) {
        setShowNavbar(true);
      }
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
    // eslint-disable-next-line
  }, [isBlogDetail, isPolicyOrTerms]);

  // Hide Google Translate UI on mount
  useEffect(() => {
    const interval = setInterval(() => {
      const frame = document.querySelector('iframe.goog-te-banner-frame');
      if (frame) frame.style.display = 'none';
      const elem = document.getElementById('google_translate_element');
      if (elem) elem.style.display = 'none';
      const logo = document.querySelector('.goog-logo-link');
      if (logo) logo.style.display = 'none';
      const gadget = document.querySelector('.goog-te-gadget');
      if (gadget) gadget.style.display = 'none';
    }, 500);
    return () => clearInterval(interval);
  }, []);

  // Hide navbar only on blog detail page when scrolling down
  const navClass = isPolicyOrTerms
    ? 'navbar scrolled'
    : `navbar${scrolled ? ' scrolled' : ''}${isBlogDetail ? ' blog-detail-dark-navbar' : ''}${isBlogDetail && !showNavbar ? ' blog-detail-navbar-hidden' : ''}`;

  return (
    <>
      <nav className={navClass}>
        <div className="navbar-container">
          <Link to="/" className="navbar-logo">
            <img src={logo} alt="ABBASS Global Properties" />
          </Link>
          <ul className="nav-menu">
            <li className="nav-item">
              <Link to="/" className="nav-link">HOME</Link>
            </li>
            <li className="nav-item">
              <Link to="/services" className="nav-link">OUR SERVICES</Link>
            </li>
            <li className="nav-item">
              <Link to="/investment-guide" className="nav-link">INVESTMENT GUIDE</Link>
            </li>
            <li className="nav-item">
              <Link to="/properties" className="nav-link">EXPLORE PROPERTIES</Link>
            </li>
            <li className="nav-item">
              <Link to="/about" className="nav-link">ABOUT US</Link>
            </li>
            <li className="nav-item">
              <Link to="/blogs" className="nav-link">BLOGS</Link>
            </li>
            <li className="nav-item">
              <Link to="/contact" className="nav-link">CONTACT US</Link>
            </li>
          </ul>
        </div>
      </nav>
      <LanguageToggle />
    </>
  );
};

export default Navbar; 